import React from 'react';
import { Check } from 'lucide-react';

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  id?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  size = 'medium',
  className = '',
  id,
}) => {
  const handleChange = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-6 h-6',
  };

  const labelSizeClasses = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
  };

  const iconSizeClasses = {
    small: 'w-3 h-3',
    medium: 'w-3.5 h-3.5',
    large: 'w-4 h-4',
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        type="button"
        id={id}
        onClick={handleChange}
        disabled={disabled}
        className={`
          ${sizeClasses[size]}
          border border-[#58616A] rounded
          flex items-center justify-center
          transition-colors
          ${checked ? 'bg-[#256EF4] border-[#256EF4]' : 'bg-white hover:border-[#256EF4]'}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
        aria-checked={checked}
        role="checkbox"
      >
        {checked && (
          <Check 
            className={`${iconSizeClasses[size]} text-white`}
            strokeWidth={3}
          />
        )}
      </button>
      
      {label && (
        <label 
          htmlFor={id}
          className={`
            ${labelSizeClasses[size]}
            text-[#131416] font-normal cursor-pointer
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
          style={{ 
            fontFamily: 'Pretendard GOV', 
            lineHeight: '1.5em' 
          }}
          onClick={!disabled ? handleChange : undefined}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;